{
  "eyebrow": "Potwierdź swój plan",
  "title": "Sprawdź i skonfiguruj.",
  "sub": "Cykl rozliczeniowy lub plan w ramach swojej linii produktowej możesz zmienić w dowolnej chwili w panelu administratora. Przejście między Time a Project ustalamy z naszym zespołem.",
  "yourPlan": "Twój plan",
  "changePlan": "Zmień plan",
  "billing": "Cykl rozliczeniowy",
  "billingMonthLabel": "Płatność miesięczna",
  "billingMonthDesc": "Elastycznie. Anuluj w dowolnym momencie.",
  "billingYearLabel": "Płatność roczna",
  "billingYearDesc": "15% zniżki. Płacisz raz w roku.",
  "addons": "Dodatki",
  "addon": {
    "ssec": "Ubezpieczenie społeczne (check-in/out@work)",
    "ssecDesc": "Tylko Belgia — automatyczna deklaracja Dimona.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Lokalizacja GPS w czasie rzeczywistym dla pojazdów firmowych. +4,80 €/pojazd/miesiąc.",
    "vehicles": "Pojazdy"
  },
  "users": {
    "title": "Ilu użytkowników potrzebujesz?",
    "help": "Każda osoba korzystająca z Done-it liczy się jako jeden użytkownik, w tym administratorzy i pracownicy.",
    "active": "użytkowników"
  },
  "estimate": "Szacowany koszt miesięczny",
  "estimateNote": "Bez VAT. Płacisz za liczbę użytkowników ustawioną tutaj i możesz ją później zmienić.",
  "estimateUnavailable": "Katalog cen niedostępny. Spróbuj ponownie, aby załadować aktualne ceny."
}
